export const invertedMessages = {
  'Required field is missing.': 'CERTS_REVIEW_STEP2_REQUIRED_FIELD',
  'Required fields ({count}) are missing.':
    'CERTS_REVIEW_STEP2_REQUIRED_FIELDS',
  Password: 'CERTS_REVIEW_STEP2_PWD',
  Type: 'CERTS_REVIEW_STEP2_TYPE',
  Draw: 'CERTS_REVIEW_STEP2_DRAW',
  Upload: 'CERTS_REVIEW_STEP2_UPLOAD',
  'Please enter {attribute} if applicable else enter N/A':
    'CERTS_REVIEW_STEP2_PLEASE_ENTER_APPLICABLE',
  'E-Signature ': 'CERTS_REVIEW_STEP2_ESIGNATURE',
  'This required field is incomplete': 'CERTS_REVIEW_STEP2_FIELD_INCOMPLETE',
  'Type your password': 'CERTS_REVIEW_STEP2_TYPE_PWD',
  'Type your name to sign': 'CERTS_REVIEW_STEP2_TYPE_NAME_TO_SIGN',
  'Draw your signature': 'CERTS_REVIEW_STEP2_DRAW_SIGNATURE',
  'Terms and Conditions': 'CERTS_REVIEW_STEP2_TERMS_AND_CONDITIONS',
  Clear: 'CERTS_REVIEW_STEP2_CLEAR',
  View: 'CERTS_REVIEW_STEP2_VIEW',
  Enter: 'CERTS_REVIEW_STEP2_ENTER',
  'I agree': 'CERTS_REVIEW_STEP2_AGREE',
  'Username is required': 'CERTS_REVIEW_STEP2_USERNAME_REQUIRED',
  'E-Signature is required': 'CERTS_REVIEW_STEP2_ESIGNATURE_REQUIRED',
  'Terms and Conditions agreement is required':
    'CERTS_REVIEW_STEP2_TNC_REQUIRED',
  Comments: 'User_CERTCOMMENTS.ATTESTATIONS',
};
